import React from 'react'
import { experience } from '../portfolio'
import { Container } from 'reactstrap'

import ExperienceCard from '../components/ExperienceCard'
import './Experience.css'

const Experience = () => {
  return (
    <section className="section section-lg">
      <Container>
        <div className="d-flex p-4">
          <div>
            <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-info">
              <i className="ni ni-briefcase-24 text-info" />
            </div>
          </div>
          <div className="pl-4">
            <h4 className="display-3 text-info">Experience</h4>
          </div>
        </div>
        <ol className="experience-timeline">
          {experience.map((data) => (
            <ExperienceCard data={data} key={`${data.company}-${data.date}`} />
          ))}
        </ol>
      </Container>
    </section>
  )
}

export default Experience
